import React, {Component} from 'react';
import {Grid, Col, Row, Button, FormControl} from 'react-bootstrap';
import moment   from 'moment'

import Select   from 'react-select'
 import {ADD_SELECTED_PRODUCTS, CLEAR_SELECTED_PRODUCTS} from 'actions/actionTypes';
 import config from  '../../../config';
import {prepareSelectOptionsList} from 'util/Utils';
import Datetime from 'react-datetime'
var subscriptionTypes =_.map(config.subscriptionTypes, function (value, key) {
    return {value: key, label: value.label}
})

export default class AdminSubscriptionSearchBox extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);


        var selectedCategory = ''
        if (!_.isUndefined(this.props.location.query.Category)){
           var foundCategory =  _.find(this.props.allCategories, function (category) {
               return  category.AncestorCategories.length == 0 &&  this.props.location.query.Category == category.TagName
           }.bind(this))
            if ( foundCategory) {
                selectedCategory = foundCategory._id
                this.subcategoriesList =  _.sortBy(prepareSelectOptionsList(
                    _.filter(this.props.allCategories,function (category) {
                         return category.AncestorCategories.length > 0 && _.includes(_.map(category.AncestorCategories,'CategoryID'), selectedCategory)
                    }),
                    {
                        label: 'CategoryName',
                        value: '_id'
                    }), 'label')
            }
       }
        var selectedSubcategory = ''
        if (!_.isUndefined(this.props.location.query.Subcategory)){
            var foundCategory =  _.find(this.props.allCategories, function (category) {
                return  category.AncestorCategories.length > 0 &&  this.props.location.query.Subcategory == category.TagName
            }.bind(this))
            selectedSubcategory = foundCategory? foundCategory._id:''
        }
        console.log('22222222222222', _.find(subscriptionTypes, {value:this.props.location.query.Types})  );
        this.state = {
              filterOptions: {
                selectedCategory:selectedCategory,
                  selectedSubcategory:selectedSubcategory,
                 perPage: _.isUndefined(this.props.location.query.perPage) ? config.table.numberPerPage : this.props.location.query.perPage,
                  fromCreatedAt: _.isUndefined(this.props.location.query.fromCreatedAt) ? '' : moment(this.props.location.query.fromCreatedAt),
                  toCreatedAt: _.isUndefined(this.props.location.query.toCreatedAt) ? '' : moment(this.props.location.query.toCreatedAt),
                searchText: _.isUndefined(this.props.location.query.searchText) ? '' : this.props.location.query.searchText,
                   Deleted:_.isUndefined(this.props.location.query.Deleted) ? 'false' : this.props.location.query.Deleted,
                  Types: _.isUndefined(this.props.location.query.Types) ?  [] : _.isArray(this.props.location.query.Types) ? _.map(this.props.location.query.Types, function (value) {
                      return _.find(subscriptionTypes,  {value:value})
                  }) : [_.find(subscriptionTypes, {value:this.props.location.query.Types})],

              }
        };

     };

    onChangePerPageNumber(option) {
        this.setState({'filterOptions': {...this.state.filterOptions, perPage: option.value}}, function () {
            this.props.search();
        });
    }

    getSearchParams(filtersChanged = {}) {
         var filterOptions = {...this.state.filterOptions, ...filtersChanged};
         console.log('filterOptions',filterOptions );
        var queryParams = {};
        if (filterOptions.perPage == 'all') {
            queryParams.all = true
        } else {
            queryParams.perPage = filterOptions.perPage;
        }
        if (filterOptions.searchText !== '') {
            queryParams.searchText = filterOptions.searchText;
        }

        if (filterOptions.fromCreatedAt !== '') {
            queryParams.fromCreatedAt = filterOptions.fromCreatedAt.toISOString()
        }
        if (filterOptions.toCreatedAt !== '') {
            queryParams.toCreatedAt = filterOptions.toCreatedAt.toISOString()
        }
        if (!_.isUndefined(filterOptions.Types)) {
            queryParams.Types = _.map(filterOptions.Types, 'value')
        }
        if (filterOptions.Deleted  ) {
            queryParams.Deleted = filterOptions.Deleted;
        }
         return {queryParams}

    }


    onSearchTextChange(event) {
        var updateOptions = {...this.state.filterOptions, searchText: event.target.value};
        this.setState({'filterOptions': updateOptions});
    }

    onCategoryChange(option) {
        var selectedSubcategory = this.state.filterOptions.selectedSubcategory,
        Subcategory = this.state.filterOptions.Subcategory;
       if (option){
             this.subcategoriesList = _.sortBy(prepareSelectOptionsList(
               _.filter(this.props.allCategories,function (category) {
                   return category.AncestorCategories.length > 0 && _.includes(_.map(category.AncestorCategories,'CategoryID'), option.value)
               }),
               {
                   label: 'CategoryName',
                   value: '_id'
               }), 'label')
           var foundSelectedSubcategory = _.find( this.subcategoriesList, function (subcategoryOption) {
               return subcategoryOption.value == selectedSubcategory
           })

           if (!foundSelectedSubcategory){
               selectedSubcategory = '';
               Subcategory = ''
           }
        } else {
           this.subcategoriesList = _.sortBy(prepareSelectOptionsList(
               _.filter(this.props.allCategories,function (category) {
                   return category.AncestorCategories.length > 0
               }),
               {
                   label: 'CategoryName',
                   value: '_id'
               }), 'label');
       }
          this.setState({
                'filterOptions': {
                    ...this.state.filterOptions,
                    selectedCategory:   option ? option.value : '',
                    selectedSubcategory:selectedSubcategory,
                    Subcategory:Subcategory,
                    Category: option ? _.find(this.props.allCategories, function (category) {
                        return   option.value == category._id
                    })['TagName'] : '',
                },
             },
            function () {
                this.props.search();
            });
    }

    onSubcategoryChange(option) {

        this.setState({
                'filterOptions': {
                    ...this.state.filterOptions,
                    selectedSubcategory:   option ? option.value : '',
                    Subcategory: option ? _.find(this.props.allCategories, function (category) {
                        return   option.value == category._id
                    })['TagName'] : '',
                },
             },
            function () {
                this.props.search();
            });
    }

    _handleKeyPress(e) {
        if (e.key === 'Enter') {
            this.props.search();
        }
    }
    onCreateTimeChange(option, createTimeOptionName) {
        var updateOptions = {...this.state.filterOptions,  [createTimeOptionName]: option};
        this.setState({'filterOptions': updateOptions}, function () {
            this.props.search();
        });
    }
    render() {
        var self = this;
         return (
            <div className="product-search-block">
                <Row  >
                    <Col xs={6} sm={4} md={4} lg={3} className="top10">
                        <Button className="btn btn-primary" onClick={this.props.toggleAllRecordsSelection}>
                            {this.props.selectAllRecords ? 'Clear selection' : 'Select all' }
                        </Button>
                    </Col>
                    <Col md={3} xs={6} className="top10">
                        <Select
                            tabIndex="0"
                            placeholder="Per Page"
                            clearable={false}
                            options={config.perPageSelectOptions}
                            onChange={this.onChangePerPageNumber.bind(this)}
                            value={self.state.filterOptions.perPage}
                        />
                    </Col>

                </Row>
                <Row>


                    <Col xs={8}     md={6} sm={6} className="top10 pright0">
                        <Col xs={6} className="pleft0  pright5">
                            <Datetime dateFormat={'MM-DD-YYYY'} timeFormat={false}
                                      onChange={(value) => this.onCreateTimeChange(value, 'fromCreatedAt')}
                                      value={this.state.filterOptions.fromCreatedAt}
                                      inputProps={{placeholder: 'From'}}/>
                        </Col>
                        <Col xs={6} className="pleft7 pright0">
                            <Datetime dateFormat={'MM-DD-YYYY'} timeFormat={false}
                                      onChange={(value) => this.onCreateTimeChange(value, 'toCreatedAt')}
                                      value={this.state.filterOptions.toCreatedAt}
                                      inputProps={{placeholder: 'To'}}/>
                        </Col>
                    </Col>
                    <Col md={3} xs={6} className="top10">
                        <FormControl type="text"
                                     defaultValue={this.state.filterOptions.searchText}
                                     onKeyPress={this._handleKeyPress.bind(this)}
                                     onChange={this.onSearchTextChange.bind(this)} ref="searchText"
                                     placeholder="Search"/>
                    </Col>
                    {/*<Col xs={6} md={3} className="top10">*/}
                             {/*<Select*/}
                                {/*tabIndex="0"*/}
                                {/*placeholder="Category"*/}
                                {/*clearable={true}*/}
                                {/*options={this.categoriesList}*/}
                                {/*onChange={this.onCategoryChange.bind(this)}*/}
                                {/*value={self.state.filterOptions.selectedCategory}*/}
                            {/*/>*/}

                    {/*</Col>*/}
                    <Col xs={6} md={3} className="top10">

                         <Select
                             tabIndex="0"
                             clearable={true}
                             multi
                            placeholder="Type"
                            options={ subscriptionTypes}
                             onChange={(selectedOptions) => {
                                  this.setState({'filterOptions': {...this.state.filterOptions, Types: selectedOptions}}, function () {
                                      this.props.search();
                                 });
                             }}

                            value={self.state.filterOptions.Types}
                        />

                    </Col>
                    <Col xs={6} md={3} className="top10">
                        <Select
                            tabIndex="0"
                            clearable={true}
                            placeholder="Deleted"
                            options={[
                                 {value: 'true', label: 'Deleted'},
                                {value: 'false', label: 'Active'}]}
                            onChange={(option) => {
                                 this.setState({
                                    'filterOptions': {
                                        ...this.state.filterOptions,
                                        Deleted:option ?  option.value : null,
                                    }
                                }, function () {
                                    this.props.search();
                                });
                            }}
                            value={this.state.filterOptions.Deleted}
                        />

                    </Col>
                    <Col md={3} xs={6} className="top10">
                        <button className="btn btn-primary" disabled={this.props.pending} onClick={(event) => self.props.search({page: 1})}
                                type="button">
                            Search
                        </button>
                    </Col>
                    {/*<Col md={3} xs={6} className="pull-right top10">*/}
                        {/*<button className="pull-right btn btn-primary" onClick={(event) => self.props.addNewSubscription()}*/}
                                {/*type="button">*/}
                            {/*Add*/}
                        {/*</button>*/}
                    {/*</Col>*/}
                </Row>

            </div>
        );

    }
}



